import { render, staticRenderFns } from "./scene2Mobile.vue?vue&type=template&id=4ca0db50&scoped=true&"
import script from "./scene2Mobile.vue?vue&type=script&lang=js&"
export * from "./scene2Mobile.vue?vue&type=script&lang=js&"
import style0 from "./scene2Mobile.vue?vue&type=style&index=0&id=4ca0db50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0db50",
  null
  
)

export default component.exports